export default __webpack_public_path__ + "static/media/Sanchez_Victor_CV.2d278f86.pdf";